import { Html } from '@react-three/drei';
import clsx from 'clsx';

import { TPosition } from '@/shared/types';
import { ThreeDimensionalPickerColors } from './state/types';

interface ThreeDimensionalAnnotationProps {
  color?: ThreeDimensionalPickerColors;
  distanceFactor?: number;
  isActive: boolean;
  onClick: () => void;
  position: TPosition;
  title: string;
}

const AnnotationColor: Record<ThreeDimensionalPickerColors, string> = {
  green: 'hover:border-mantis',
  orange: 'hover:border-squash'
};

export const ThreeDimensionalAnnotation = ({
  color = 'green',
  distanceFactor = 3,
  isActive = false,
  onClick,
  position: [x, y, z],
  title
}: ThreeDimensionalAnnotationProps) => {
  return (
    <mesh position={[x, y, z]}>
      <Html center distanceFactor={distanceFactor}>
        <div
          className={clsx(
            'w-fit min-w-[7rem] sm:min-w-[10rem] flex justify-center border-2 rounded-full backdrop-blur-almost-md py-2 px-4 sm:py-2.5 sm:px-6 cursor-pointer transition-colors',
            isActive
              ? 'border-mantis bg-baltic-sea/90 ring-4 ring-mantis/20'
              : 'border-transparent bg-baltic-sea/50',
            AnnotationColor[color]
          )}
          onClick={onClick}
        >
          <div
            className={clsx(
              'text-sm sm:text-2xl text-center leading-2 sm:leading-8.5 font-mono font-normal tracking-tighter select-none whitespace-nowrap',
              isActive ? 'text-mantis' : 'text-white'
            )}
          >
            {title}
          </div>
        </div>
      </Html>
    </mesh>
  );
};
